import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e485bc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card custom-panel mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "card-header bg-panel-grey"
}
const _hoisted_3 = { class: "header-row" }
const _hoisted_4 = { class: "panel-title mb-0" }
const _hoisted_5 = { class: "card-body panel-content" }


export default /*#__PURE__*/_defineComponent({
  __name: 'summary-custom-panel',
  props: {
  /**
   *  Panel title text displayed in the header
   * @type {string}
   * @default undefined
   */
  title: {
    type: String,
    default: undefined,
  },
  /**
   * The icon, such as fa-regular fa-at
   * @type {string}
   * @default undefined
   */
  icon: {
    type: String,
    default: undefined,
  },
  /**
   * Additional CSS classes to customize the icon styling
   * @type {string}
   * @default ""
   */
  iconClass: {
    type: String,
    default: "",
  },
  /**
   * Colour of the icon.
   * @type {string}
   * @default "#666"
   */
  iconColor: {
    type: String,
    default: "#666",
  },
  /**
   * Size of the icon.
   * @type {string}
   * @default "1.2rem"
   */
  iconSize: {
    type: String,
    default: "1.2rem",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title || __props.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (__props.icon)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass([[__props.icon, __props.iconClass], "panel-icon"]),
                  style: _normalizeStyle({ color: __props.iconColor, fontSize: __props.iconSize })
                }, null, 6))
              : _createCommentVNode("", true),
            _createElementVNode("h5", _hoisted_4, _toDisplayString(__props.title), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})